import { Injectable } from "@angular/core";
import { Subject, Observable, BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class ChatbotWindowSizeService {
  private _chatbotPopupSubject: Subject<boolean> = new Subject<boolean>();
  public chatbotPopupObservable: Observable<boolean> = this._chatbotPopupSubject.asObservable();

  // Track chatbot width changes
  private _chatbotWidthSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public chatbotWidthObservable: Observable<number> = this._chatbotWidthSubject.asObservable();

  setChatbotPopupSubject(result: boolean): void {
    this._chatbotPopupSubject.next(result);
  }

  // Method to update chatbot width
  setChatbotWidth(width: number): void {
    this._chatbotWidthSubject.next(width);
  }

  getChatbotWidth(): number {
    return this._chatbotWidthSubject.value;
  }
}
